export const shopRoutes = [
    {
        path: '/store',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/home'));
            reject(error);
        }),
    },
    {
        path: '/store/signup',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/Signup'));
            reject(error);
        }),
    },
    {
        path: '/store/dashboard',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/Dashboard'));
            reject(error);
        }),
    },
    {
        path: '/store/login',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/login'));
            reject(error);
        }),
    },
    {
        path: '/store/edit-profile',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/EditProfile'));
            reject(error);
        }),
    },
    {
        path: '/store/document',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/Document'));
            reject(error);
        }),
    },
    {
        path: '/store/password',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/changePassword'));
            reject(error);
        }),
    },
    {
        path: '/store/payout',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/Payout/PayoutList'));
            reject(error);
        }),
    },
    {
        path: '/store/addPayout',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/Payout/AddPayout'));
            reject(error);
        }),
    },
    {
        path: '/store/payout/failure',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/Payout/FailedPayout'));
            reject(error);
        }),
    },
    {
        path: '/store/operating-hours',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/operationHours'));
            reject(error);
        }),
    },
    {
        path: '/store/menu',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/category'));
            reject(error);
        }),
    },
    {
        path: '/store/menu/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/addMenu'));
            reject(error);
        }),
    },
    {
        path: '/store/menu/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/editMenu'));
            reject(error);
        }),
    },
    {
        path: '/store/menu/:id/item',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/item'));
            reject(error);
        }),
    },
    {
        path: '/store/preparation-time',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/preparationTime'));
            reject(error);
        }),
    },
    {
        path: '/store/tax',
        load: () => new Promise((resolve, reject) => {
          resolve(require('./shop/tax'));
          reject(error);
        }),
      },
    {
        path: '/store/additional-fees',
        load: (error) => new Promise((resolve, reject) => {
            resolve(require('./shop/additionalFees'));
            reject(error);
        }),
    }, {
        path: '/store/order-management/:type',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/orderManageContainer'));
            reject(error);
        }),
    },
    {
        path: '/store/order-details/:type/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/orderDetails'));
            reject(error);
        }),
    },
    {
        path: '/store/transaction/:type',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/transaction'));
            reject(error);
        }),
    },
    {
        path: '/password/verification',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/changePasswordUsingToken/'));
            reject(error);
        }),
    },
    {
        path: '/store/menu/modifier-groups',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/modifierGroups'));
            reject(error);
        }),
    },
    {
        path: '/store/menu/modifier-groups/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/addModifierGroups'));
            reject(error);
        }),
    },
    {
        path: '/store/menu/modifier-groups/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/editModifierGroups'));
            reject(error);
        }),
    },
    {
        path: '/store/menu/:menuId/item/:subMenuId/add',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/addItem'));
            reject(error);
        }),
    },
    {
        path: '/store/menu/:menuId/item/:subMenuId/edit/:id',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/editItem'));
            reject(error);
        }),
    },
     {
        path: '/store/reviews',
        load: () => new Promise((resolve, reject) => {
            resolve(require('./shop/reviews'));
            reject(error);
        }),
    },
];